import type { Cart } from '@/modules/cart/domain/Cart';
import type { CartRepository } from '@/modules/cart/domain/CartRepository';

const addToSaveForLater = (
  repository: CartRepository,
  sku: string,
  lineItemId: string
): Promise<Cart> => {
  return repository.addToSaveForLater(sku, lineItemId);
};

export default addToSaveForLater;
